import React from 'react';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import {
  amountComparator,
  cellRenderer,
} from '../../../../SharedModules/utilities/utilities';

const unitRenderer = (params) => {
  const { value } = params;
  if (params?.data?.isBottomRow) {
    const pinnedValue = parseFloat(params?.value);
    if (pinnedValue < 0) {
      return (
        <b>
          <span
            style={{ color: '#eb0000', textAlign: 'right', display: 'inline' }}
          >
            (
            {` ${Math.abs(parseFloat(pinnedValue))?.toLocaleString('en-US', {
              minimumFractionDigits: 4,
              maximumFractionDigits: 4,
            })}`}
            )
          </span>
        </b>
      );
    }
    if (pinnedValue) {
      return (
        <div style={{ textAlign: 'right' }}>
          <b>
            {` ${parseFloat(pinnedValue)?.toLocaleString('en-US', {
              minimumFractionDigits: 4,
              maximumFractionDigits: 4,
            })}`}
          </b>
        </div>
      );
    }
    return (
      <div style={{ textAlign: 'right' }}>
        <b>{' 0.0000'}</b>
      </div>
    );
  }
  if (value < 0) {
    return (
      <span style={{ color: '#eb0000', textAlign: 'right', display: 'inline' }}>
        {` ( ${Math.abs(parseFloat(value))?.toLocaleString('en-US', {
          minimumFractionDigits: 4,
          maximumFractionDigits: 4,
        })}
       )`}
      </span>
    );
  }
  if (value) {
    return (
      <div style={{ textAlign: 'right' }}>{` ${parseFloat(
        value
      )?.toLocaleString('en-US', {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4,
      })}`}</div>
    );
  }
  return <div style={{ textAlign: 'right' }}>{' 0.0000'}</div>;
};
export const AllManufacturer = [
  {
    headerName: 'Select All',
    minWidth: Styles.Width_50,
    headerCheckboxSelection: true, // For header check box
    filter: false,
    resizable: true,
    field: 'checkSelect',
    editable: false,
    suppressMenu: true,
    sortable: false,
    checkboxSelection: true,
    pdfExportOptions: {
      skipColumn: true,
    },
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
  },
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    cellRenderer: 'GenericCodeTextBox',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    // cellRenderer: 'GenericCodeTextBox',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const manufacturerOutstandingBalanceGrid = [
  {
    headerName: 'Manufacturer',
    field: 'manufacturer',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_230,
    wrapText: true,
    columnSpan: 3,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'NDC Count',
    field: 'ndcCount',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_110,
    cellRenderer: 'GenericCodeTextBox',
    comparator: amountComparator,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    excelAlignment: 'right',
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Total Units Invoiced',
    field: 'totReimbursedUnits',
    editable: false,
    suppressMenu: false,
    sortable: true,
    isTextColorRed: true,
    alignment: 'right',
    exportZeroesFour: true,
    minWidth: Styles.Width_138,
    cellRenderer: unitRenderer,
    comparator: amountComparator,
    excelAlignment: 'right',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total Units Paid',
    field: 'paidUnits',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    isTextColorRed: true,
    exportZeroesFour: true,
    alignment: 'right',
    excelAlignment: 'right',
    cellRenderer: unitRenderer,
    comparator: amountComparator,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    // alignment: 'right',
  },
  {
    headerName: 'Total Outstanding Unit Balance',
    field: 'unpaidUnits',
    editable: false,
    suppressMenu: false,
    isTextColorRed: true,
    exportZeroesFour: true,
    alignment: 'right',
    sortable: true,
    minWidth: Styles.Width_158,
    cellRenderer: unitRenderer,
    isCount: true,
    comparator: amountComparator,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    excelAlignment: 'right',
    // alignment: 'right',
  },
  {
    headerName: 'Total Units Disputed',
    field: 'disputedUnits',
    editable: false,
    suppressMenu: false,
    sortable: true,
    isTextColorRed: true,
    exportZeroesFour: true,
    alignment: 'right',
    minWidth: Styles.Width_130,
    comparator: amountComparator,
    cellRenderer: unitRenderer,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    excelAlignment: 'right',
    // alignment: 'right',
  },
  {
    headerName: 'Total Dollars Invoiced',
    field: 'totDollerInvoiced',
    editable: false,
    suppressMenu: false,
    sortable: true,
    isAmount: true,
    minWidth: Styles.Width_150,
    isTextColorRed: true,
    alignment: 'right',
    printPrefixValue: '$',
    cellRenderer: cellRenderer,
    comparator: amountComparator,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    // alignment: 'right',
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      // textMatcher: textMatcherAmount,
    },
  },
  {
    headerName: 'Total Dollars Paid',
    field: 'totDollerPaid',
    editable: false,
    suppressMenu: false,
    sortable: true,
    isAmount: true,
    minWidth: Styles.Width_150,
    isTextColorRed: true,
    alignment: 'right',
    // alignment: 'right',
    printPrefixValue: '$',
    cellRenderer: cellRenderer,
    comparator: amountComparator,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      // textMatcher: textMatcherAmount,
    },
  },
  {
    headerName: 'Total Dollars Outstanding',
    field: 'totDollerOutstanding',
    editable: false,
    suppressMenu: false,
    sortable: true,
    isAmount: true,
    minWidth: Styles.Width_160,
    printPrefixValue: '$',
    isTextColorRed: true,
    alignment: 'right',
    cellRenderer: cellRenderer,
    comparator: amountComparator,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      // textMatcher: textMatcherAmount,
    },

    // alignment: 'right',
  },
  {
    headerName: 'Total Dollars Disputed',
    field: 'totDollerDisputed',
    editable: false,
    suppressMenu: false,
    sortable: true,
    isAmount: true,
    minWidth: Styles.Width_160,
    printPrefixValue: '$',
    isTextColorRed: true,
    alignment: 'right',
    cellRenderer: cellRenderer,
    comparator: amountComparator,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      // textMatcher: textMatcherAmount,
    },
    // alignment: 'right',
  },
];
